import { MaybePromise } from 'component_utils/utils';
import { OnEnterArgs, State } from '..';

type Decide<S, P, R> = (args: OnEnterArgs<S, P, R>) => MaybePromise<boolean>;

interface EventProps {}

interface Config<S, P, A, R> {
  nextStateIfTrue: number;
  nextStateIfFalse: number;
  decide: Decide<S, P, R>;
}

const StateDecide = function <S, P extends EventProps, A extends { hint: string }, R>({
  nextStateIfFalse,
  nextStateIfTrue,
  decide,
}: Config<S, P, A, R>): State<S, P, A, R> {
  return {
    onEnter: async (args) => {
      return {
        type: 'MOVE',
        nextState: (await decide(args)) ? nextStateIfTrue : nextStateIfFalse,
      };
    },

    nodeName: 'T.states.decision',
    outputs: [
      {
        name: 'ifTrue',
        to: nextStateIfTrue,
      },
      {
        name: 'ifFalse',
        to: nextStateIfFalse,
      },
    ],
  };
};

export default StateDecide;
